var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style['signup-step']},[_c('AppTransition',{attrs:{"name":"translate-y-sm","appear":""}},[(_vm.title)?_c('div',{class:[
        _vm.$style['signup-step__title'],
        _vm.$style[`signup-step__title--${_vm.theme}`],
      ],style:({
        transitionDelay: '0s',
      }),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]),_vm._v(" "),_c('AppTransition',{attrs:{"name":"translate-y-sm","appear":""}},[(_vm.subtitle)?_c('div',{class:[
        _vm.$style['signup-step__subtitle'],
        _vm.$style[`signup-step__subtitle--${_vm.theme}`],
      ],style:({
        transitionDelay: '0.2s',
      }),domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e()]),_vm._v(" "),_c('AppTransition',{attrs:{"name":"scale","appear":""}},[(_vm.$slots.default)?_c('div',{class:[
        _vm.$style['signup-step__content']
      ],style:({
        transitionDelay: '0.5s',
      })},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }